var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.668 3.33331C17.5846 3.33331 18.335 4.08364 18.335 5.00031V15.0003C18.3348 15.9168 17.5845 16.6663 16.668 16.6663H3.33496C2.4184 16.6663 1.66815 15.9168 1.66797 15.0003L1.67676 5.00031C1.67676 4.08364 2.41829 3.33331 3.33496 3.33331H16.668ZM10.001 9.16632L3.33496 5.00031V6.66632L10.001 10.8333L16.668 6.66632V5.00031L10.001 9.16632Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.45bfd301c3915f588f0150839cb3cef0.svg";
export { ForwardRef as ReactComponent };